module.exports = __webpack_public_path__ + "img/redpacket.59ffa993.png";